class SiteModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.hasTrigger = this.dataset.siteModalHasTrigger

    this.validate()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.externalEls.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  validate () {
    if (!this.externalEls?.trigger?.exists && this.hasTrigger === 'true') {
      throw new Error(`Missing trigger element`)
    }
  }

  handleTrigger (e) {
    if (e.currentTarget.dataset.siteModalKey !== this.dataset.siteModalKey) {
      return
    }

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('site-modal')) {
  customElements.define('site-modal', SiteModal)
}
